import React from 'react'
import {connect} from 'react-redux'
import i18n from "../../../i18nSetup";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import ListItemIcon from '@mui/material/ListItemIcon';
import Typography from '@mui/material/Typography';
import useStyles from '../../styles/style'
import {settingQueryParam} from "../../actions/form";
import {TRIP_MODES} from '../../constants';
import ModeIcon from "../icons/mode-icon";
import {TypographyBasic, TypographyMediumSize} from "../../styles/components/customTypography";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";


function TransitTypes(props) {
    const {classes} = useStyles();
    const {modeRoute} = props;

    const handleSelected = (event) => {

        let modeObj = modeRoute;
        if (modeRoute.indexOf(event.target.value) > -1)
        {
            modeObj = modeRoute.replace("," + event.target.value, "");
            if(modeObj === 'WALK')
                modeObj += ',TRANSIT'
        }
        else
        {
            if(modeRoute.indexOf('TRANSIT') > -1)
            {
                modeObj = modeRoute.replace("TRANSIT", event.target.value);
            }
            else
            modeObj += ',' + event.target.value
        }
        props.settingQueryParam({mode: modeObj })
    };

    return (
      <Box mt={2}>
          <Stack direction={'column'} spacing={1.5}>
              <Divider flexItem/>
              <TypographyMediumSize>
                  {i18n.t('transitTypes')}
              </TypographyMediumSize>
              <List dense sx={{padding: 'unset'}}>
                  {TRIP_MODES.map((mode) => (
                    <ListItem button key={mode.value} sx={{paddingRight: 'unset', paddingLeft: 'unset'}}>
                        <ListItemIcon className={classes.iconList}>
                            <ModeIcon mode={mode.value}/>
                        </ListItemIcon>
                        <ListItemText>
                            <TypographyBasic fw={400}>
                                {i18n.t(mode.key)}
                            </TypographyBasic>
                        </ListItemText>
                        <ListItemSecondaryAction>
                            <Checkbox
                              sx={{
                                  color: '#4B33A5',
                                  '&.Mui-checked': {
                                      color: '#4B33A5',
                                  },
                              }}
                              onClick={handleSelected}
                              value={mode.value}
                              checked={modeRoute.indexOf(mode.value) > -1}
                            />
                        </ListItemSecondaryAction>
                    </ListItem>
                  ))}

              </List>
          </Stack>
      </Box>
    );
}
const mapStateToProps = (state, ownProps) => {
    return {
        modeRoute: state.otp.currentQuery.mode
    }
}
const mapDispatchToProps = {
    settingQueryParam
}
export default connect(mapStateToProps,mapDispatchToProps) (TransitTypes)